import SEModal from "../components/seModal";
import * as Sentry from "@sentry/react";


export const handleException = (error, title, description) => {
    // 1- Ignore 401 errors
    if (error.response?.status === 401) return;

    // 2- Add Sentry error handling
    console.error("SE/APP Error: Title:", title);
    console.error("SE/APP Error: Description:", description);
    Sentry.withScope(scope => {
        if (title) scope.setTag("error.title", title);
        if (description) scope.setExtra("error.description", description);
        Sentry.captureException(error);
    });

    // 3- Show error message
    let errorMessage =
        error?.response?.data?.errorMessage ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        error;
    if (description && typeof description === "string") errorMessage = description + (errorMessage || "");

    SEModal.fire({
        type: "error",
        title: title || "Unexpected Error",
        description: errorMessage,
        confirmButtonText: "Close",
        showConfirmButton: true,
    });
}